import { EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Flex, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import TableAntd from "components/elements/Table/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import PayrollPerMonthModal from "features/payroll/components/PayrollModal/PayrollPerMonthModal";
import PeriodEditModal from "features/payroll/components/PayrollModal/PeriodEditModal";
import { useTranslation } from "react-i18next";

const PayrollPeriodTable = ({
    payrollPerMonth = [],
    setPayrollPerMonthList = () => { },
    getPayrollPerMonth = () => { },
    isModalOpenPerMonth = false,
    setModalOpenPerMonth = () => { },
    isLoading = false,
    onCancelPerMonth = () => { },
    isModalOpen = false,
    visible = false,
    setModalOpen = () => { },
    payrollPeriodList = [],
    onEdit = () => { },
    initialValues = {},
    onCancel = () => { },
    onEditSubmit = () => { },
    getPayrollPeriodList = () => { },
    getPayrollPeriodDetails = () => { },
    onViewPayrollPeriodCalculateDetails = () => { },
    getPayrollPeriodCalculateDetailsModal = () => { },
    form = null,
    permissions
}) => {
    const { t, i18n } = useTranslation();
    const [formModal] = useForm(form);


    // function convertDateString(dateStr) {
    //     return dayjs(dateStr, "YYYY-MM-DD").format(i18n.language === "en" ? "DD MMMM YYYY" : "DD MMMM BBBB")
    // }

    const columns = [
        {
            title: <div className="text-table">{t('no')}</div>,
            dataIndex: "periodNo",
            key: "periodNo",
            width: "10%",
            align: "center",
            render: (_, record, idx) => {
                return <span style={{
                    color: "#313131",
                    backgroundColor: "#F5F6F7",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                }}>
                    {idx + 1}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('month')}</div>,
            dataIndex: "monthStr",
            key: "monthStr",
            width: "65%",
            render: (_, record) => {
                // console.log(text, record);
                // return text ? text : convertDateString(record.startPeriod) + " - " + convertDateString(record.endPeriod)
                return <span>{i18n.language === "en"
                    ? record?.monthStrEn.charAt(0).toUpperCase() + record?.monthStrEn.slice(1).toLowerCase()
                    : record?.monthStr}</span>
            }
        },
        // {
        //     title: <div className="text-table">{t("payment_period.label.employment_type")}</div>,
        //     dataIndex: "employmentType",
        //     key: "employmentType",
        //     // width: "60px",
        //     render: (text, record) => {
        //         let language = i18n.language === 'en' ? "En" : ""
        //         const employmentTypeName = record?.employmentType?.[0]?.["name" + language];
        //         return employmentTypeName ? EmploymentType(employmentTypeName) : null;
        //     }
        // },
        // {
        //     title: <div className="text-table">{t("payment_period.label.payment_date")}</div>,
        //     dataIndex: "paymentDate",
        //     key: "paymentDate",
        //     width: "14%",
        //     render: (text, record) => {
        //         return text && convertDateString(text)
        //     }
        // },
        {
            title: <div className="text-table">{t("payment_period.label.total_employee")}</div>,
            dataIndex: "employee",
            key: "employee",
            width: "15%",
            render: (_, record) => {
                return <Flex style={{ placeSelf: "center" }}>{record?.employee + " " + (i18n.language === 'en' ? "" : t("expense.expense-detail.person"))}</Flex>
            }
        },
        {
            title: <div className="text-table">{t("payment_period.label.paid_net")}</div>,
            dataIndex: "totalPaid",
            key: "totalPaid",
            align: "center",
            width: "20%",
            render: (_, record) => {
                return <Flex style={{ justifySelf: "right" }}>{
                    visible && record?.totalPaid !== null
                        ? `฿ ${get2DecimalPointsWithCommas(record?.totalPaid)}`
                        : `฿ ${record?.totalPaid ? record?.totalPaid : "x.xx"}`
                }</Flex>
            }
        },
        {
            title: "",
            key: "action",
            width: '60px',
            fixed: "right",
            align: "center",
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: async () => {
                                        if (record?.year && record?.month) {
                                            setModalOpenPerMonth(true);
                                            getPayrollPerMonth({ year: record?.year, month: record?.month });
                                            console.log("record ", record?.year, record?.month);
                                        } else {
                                            console.log("Invalid data: Year or Month is null", record);

                                        }
                                    },
                                    label: `${t("action.view")}`,
                                    icon: (
                                        <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },

                            ],
                        }}
                        placement="bottomRight"
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        },
    ]

    return (
        <>
            {permissions?.ACCESS && (
                <>
                    <TableAntd
                        loading={isLoading}
                        pagination={{ size: 12 }}
                        noPage={true}
                        dataSource={payrollPeriodList?.map((o, index) => { return { ...o, key: index, id: index } })}
                        rowKey={(record) => record.id}
                        columns={columns}
                        scroll={{
                            x: 'calc(480px + 50%)',
                        }}
                    />
                    <PeriodEditModal
                        form={formModal}
                        isModalOpen={isModalOpen}
                        onCancel={onCancel}
                        initialValues={initialValues}
                        onEditSubmit={onEditSubmit}
                    />

                    <PayrollPerMonthModal
                        loading={isLoading}
                        payrollPerMonth={payrollPerMonth}
                        isOpen={isModalOpenPerMonth}
                        onCancel={onCancelPerMonth}
                        onViewPayrollPeriodCalculateDetails={onViewPayrollPeriodCalculateDetails}
                    />
                    {getPayrollPeriodCalculateDetailsModal()}
                </>
            )}
        </>
    )
}

export default PayrollPeriodTable; 